export const regions = {
  london: {
    id: 'london',
    name: 'London',
    flag: '🇬🇧'
  },
  montreal: {
    id: 'montreal',
    name: 'Montreal',
    flag: '🇨🇦'
  },
  northvirginia: {
    id: 'northvirginia',
    name: 'USA',
    flag: '🇺🇸'
  }
} as const
